<acl-ngx-modal [open]="open" [width]="modalProps.width" [closeButton]="modalProps.closeButton" (toggle)="closeModal()">
  <acl-ngx-modal-header>
    {{modalProps.headerContent}}
  </acl-ngx-modal-header>
  <acl-ngx-modal-body>
    <modal-body-wrapper [bodyContent]="modalProps.bodyContent">
    </modal-body-wrapper>
  </acl-ngx-modal-body>
  <acl-ngx-modal-footer>
    <modal-footer-wrapper [footerContent]="modalProps.footerContent" (close)="closeModal()">
    </modal-footer-wrapper>
  </acl-ngx-modal-footer>
</acl-ngx-modal>